import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addSearch, fetchSavedSearches } from '../../actions/savedSearches';
import { SavedSearchModal } from '../search/results-ts';
import { findExistingAlert } from '../../utils/alertComparison';
import FiltersModel from '../../models/Filters';
import i18n from '../../i18n';
import UserModel from '../../models/User';
import Analytics from '../../utils/analytics';
import { AlertDialog, Text } from '@homeexchange/design';

export class Alert extends React.PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(UserModel),
        alerts: PropTypes.arrayOf(PropTypes.object),
        search: PropTypes.object.isRequired,
        iconOnly: PropTypes.bool,
        addAlert: PropTypes.func,
        fetchSavedSearches: PropTypes.func
    };

    constructor(props) {
        super(props);
        const { alerts, search } = props;
        this.state = {
            success: false,
            errorPopup: false,
            alert: this.getExistingAlert(alerts, search),
            createAlert: null,
            isOpen: false,
            openModalAlertAlreadyExists: false
        };
        this.saveSearch = this.saveSearch.bind(this);
        this.buttonRef = React.createRef();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { alerts, search } = nextProps;
        this.setState({
            alert: this.getExistingAlert(alerts, search)
        });
    }

    getExistingAlert(alerts, search) {
        return findExistingAlert(alerts, search);
    }

    saveSearch(event) {
        event.preventDefault();

        const { search, user } = this.props;
        const { alert } = this.state;

        if (!user) {
            $('.btn-signup').trigger('click');
            return;
        }

        Analytics.trackGTM('SearchResults', {
            event_data: {
                action: 'click',
                area: 'search',
                text: 'save_this_destination',
                origin: 'top_menu',
                search_value: search.query
            }
        });

        if (alert) {
            this.setState({
                openModalAlertAlreadyExists: true
            });
        } else {
            const filtersFromUrl = FiltersModel.fromUrl().toJSON();
            this.props.addAlert(search.query, filtersFromUrl).then((response) => {
                this.setState({
                    createAlert: response,
                    isOpen: true
                });
                this.props.fetchSavedSearches();
            });
        }
    }

    render() {
        const { user } = this.props;
        const { alert } = this.state;

        if (!user) {
            return null;
        }

        if (!this.props.search.query || this.props.search.query.length === 0) {
            return null;
        }

        return (
            <>
                <a
                    ref={this.buttonRef}
                    className={alert ? 'btn btn-alert saved' : 'btn btn-default'}
                    href="#"
                    onClick={this.saveSearch}
                >
                    <i
                        className={
                            alert ? 'icon icon-ok surrounded' : 'icon-preferred-destinations btn-alert'
                        }
                    />
                    <span className="btn-alert-text">
                        {alert ? i18n.t('search:destination.saved') : i18n.t('search:destination.save')}
                    </span>
                </a>
                <SavedSearchModal
                    isOpen={this.state.isOpen}
                    onClose={() => this.setState({ isOpen: false })}
                    createdAlert={this.state.createAlert}
                />
                <AlertDialog
                    isOpen={this.state.openModalAlertAlreadyExists}
                    onConfirmAction={() => this.setState({ openModalAlertAlreadyExists: false })}
                    confirmActionText={'OK'}
                    title={i18n.t('user:modal_travelWishlist_alreadySaved_title')}
                    onDismissAction={() => (window.location.href = i18n.t('url:saved_search'))}
                    dismissActionText={i18n.t('user:modal_travelWishlist_alreadySaved_cta')}
                    iconStatus="info"
                >
                    <Text>{i18n.t('user:modal_travelWishlist_alreadySaved_body')}</Text>
                </AlertDialog>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    homes: state.homes,
    alerts: state.savedSearches
});

const mapDispatchToProps = (dispatch) => ({
    addAlert: bindActionCreators(addSearch, dispatch),
    fetchSavedSearches: bindActionCreators(fetchSavedSearches, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
